export enum DermloopAlternativeImageType {
  Flash = 'flash',
  NoFlash = 'no-flash',
}
